
export function formatDate(inputDate) {
    const date = new Date(inputDate);
    const year = date.getFullYear();

    let month = date.getMonth() + 1;
    let dt = date.getDate();

    return year + '-' + (month < 10 ? '0' + month : month) + '-' + (dt < 10 ? '0' + dt : dt);
}